/* eslint-disable camelcase */
import axios from 'axios';

const BillLineItemService = {
  async createBillLineItem({ formValues, billId }) {
    const response = await axios.post('/bill_line_item', {
      ...formValues,
      bill_id: billId,
      status: 'pending',
    });

    return response.data;
  },

  async updateBillLineItem({ billLineItemId, formValues }) {
    const response = await axios.put(
      `/bill_line_item/${billLineItemId}`,
      formValues
    );

    return response.data;
  },

  async deleteBillLineItem(billLineItemId) {
    const response = await axios.delete(`/bill_line_item/${billLineItemId}`);

    return response.data;
  },

  async addBillLineItemToBillPayment({ billLineItemId, billPaymentId }) {
    const response = await axios.post(
      `/bill_line_item/${billLineItemId}/add_to_bill_payment/${billPaymentId}`
    );

    return response.data;
  },
};

export default BillLineItemService;
